import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import { authSlice, authMiddleware, initializeAuth } from './auth/auth.slice'
import { appSlice } from './app/app.slice'

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    app: appSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(authMiddleware),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>

initializeAuth(store.dispatch).catch(console.error)
